import { FETCH_ORDER_SUCCESS, FETCH_ORDER_REQUEST, FETCH_ORDER_FAILURE, FETCH_ORDER_REST } from "@/redux/actions";
const initialState = {
    data: null,
    loading: false,
    error: null,
};
const getOrderReducer = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_ORDER_SUCCESS:
            return Object.assign(Object.assign({}, state), { loading: false, error: null, data: action.payload });
        case FETCH_ORDER_REQUEST:
            return Object.assign(Object.assign({}, state), { loading: true, data: null, error: null });
        case FETCH_ORDER_FAILURE:
            return Object.assign(Object.assign({}, state), { loading: false, error: action.payload });
        case FETCH_ORDER_REST:
            return Object.assign(Object.assign({}, state), { loading: false, data: null });
        default:
            return state;
    }
};
export default getOrderReducer;
